import { styled } from "@mui/material/styles";
const StyledLink = styled("a")(({ theme }) => ({
  color: theme.palette.link.main,
  fontWeight: "bold",
  textDecoration: "none",
  "&:hover": {
    color: theme.palette.link.hovered,
  },
}));
export default StyledLink;
